export var RequestStateEnum;
(function (RequestStateEnum) {
  RequestStateEnum["pending"] = "pending";
  RequestStateEnum["fulfilled"] = "fulfilled";
  RequestStateEnum["rejected"] = "rejected";
})(RequestStateEnum || (RequestStateEnum = {}));